const SET_USER_ACTIVITY = (state, data) => {
  state.isEndOfTail = data.isEndOfTail
  state.userActivityItems = {...state.userActivityItems, ...data.userFeedItems}
  state.latestSequenceNumber = data.latestSequenceNumber
}

export default {
  SET_USER_ACTIVITY
}



// WEBPACK FOOTER //
// ./src/store/modules/user/activity/mutations.js